import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  HStack,
  InputRightElement,
  Stack,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Link,
  useToast,
  Select,
} from "@chakra-ui/react";
import { useState } from "react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../auth/AuthContext";

const initialState = {
  name: "",
  usuario: "",
  filial: "",
  cargo: "",
  email: "",
  password: "",
};

export default function CreateAcc() {
  const { createUserHook, setUser, user } = UserAuth();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [addUser, AddSetUser] = useState(initialState);
  const { name, usuario, filial, cargo, email, password } = addUser;
  const toast = useToast();

  const handleChange = (e) => {
    AddSetUser({
      ...addUser,
      [e.target.name]: e.target.value,
    });
  };

  const CriarConta = async (e) => {
    if (!name || !usuario || !filial || !cargo || !email || !password) {
      return toast({
        title: "Por favor, preencha todos os campos",
        position: "top-right",
        status: "error",
        isClosable: true,
      });
    }
    if (password.length > 5) {
      await createUserHook(name, usuario, filial, cargo, email, password)
        .then(() => {
          toast({
            title: `Usuário criado com sucesso`,
            status: "success",
            isClosable: true,
          });
        }, navigate("/login", { replace: true }))

        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          toast({
            title: errorMessage,
            status: "error",
            isClosable: true,
          });
        });
    } else
      return toast({
        title: "A senha deve ser no mínimo com 6 caracteres",
        position: "top-right",
        status: "error",
        isClosable: true,
      });
  };

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12} px={6}>
        <Stack align={"center"}>
          <Heading fontSize={"4xl"} textAlign={"center"}>
            Criar Usuário
          </Heading>
          <Text fontSize={"lg"} color={"gray.600"}>
            Preencha com atenção
          </Text>
        </Stack>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
        >
          <Stack spacing={4}>
            <HStack>
              <Box>
                <FormControl id="firstName" isRequired>
                  <FormLabel>Nome</FormLabel>
                  <Input
                    type="text"
                    id="name"
                    name="name"
                    value={name}
                    onChange={handleChange}
                  />
                </FormControl>
              </Box>
              <Box>
                <FormControl id="usuario" isRequired>
                  <FormLabel>Usuário</FormLabel>
                  <Input
                    type="text"
                    id="usuario"
                    name="usuario"
                    value={usuario}
                    onChange={handleChange}
                  />
                </FormControl>
              </Box>
            </HStack>
            <HStack>
              <Box>
                <FormLabel>Filial</FormLabel>
                <Select
                  name="filial"
                  id="filial"
                  value={filial}
                  onChange={handleChange}
                >
                  <option value="BARRA GRANDE">BARRA GRANDE</option>
                  <option value="BOIPEBA">BOIPEBA</option>
                  <option value="CAIRU">CAIRU</option>
                  <option value="CAMAMU">CAMAMU</option>
                  <option value="CRUZEIRO DE LAJE">CRUZEIRO DE LAJE</option>
                  <option value="GAMBOA">GAMBOA</option>
                  <option value="GANDU">GANDU</option>
                  <option value="ITAMARATY">ITAMARATY</option>
                  <option value="JIQUIRIÇÁ">JIQUIRIÇÁ</option>
                  <option value="LAJE">LAJE</option>
                  <option value="MARAÚ">MARAÚ</option>
                  <option value="MUTUÍPE">MUTUÍPE</option>
                  <option value="NILO PEÇANHA">NILO PEÇANHA</option>
                  <option value="PALMA">PALMA</option>
                  <option value="TEOLÂNDIA">TEOLÂNDIA</option>
                  <option value="UBAÍRA">UBAÍRA</option>
                  <option value="WENCESLAU">WENCESLAU</option>
                  <option value="TODAS">TODAS</option>
                </Select>

                {/* <Input
                    type="text"
                    id="filial"
                    name="filial"
                    value={filial}
                    onChange={handleChange}
                  /> */}
              </Box>
              <Box>
                <FormControl id="cargo" isRequired>
                  <FormLabel>Cargo</FormLabel>
                  <Input
                    type="text"
                    id="cargo"
                    name="cargo"
                    value={cargo}
                    onChange={handleChange}
                  />
                </FormControl>
              </Box>
            </HStack>
            <HStack></HStack>
            <FormControl id="email" isRequired>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="password" isRequired>
              <FormLabel>Senha</FormLabel>
              <InputGroup>
                <Input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={password}
                  onChange={handleChange}
                />
                <InputRightElement h={"full"}>
                  <Button
                    variant={"ghost"}
                    onClick={() =>
                      setShowPassword((showPassword) => !showPassword)
                    }
                  >
                    {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>
            <Stack spacing={10} pt={2}>
              <Button
                loadingText="Submitting"
                size="lg"
                bg={"blue.400"}
                color={"white"}
                _hover={{
                  bg: "blue.500",
                }}
                onClick={CriarConta}
              >
                Criar usuário
              </Button>
            </Stack>
            <Stack pt={6}>
              <Text align={"center"}>
                Já tem uma conta?{" "}
                <Link color={"blue.400"} onClick={() => navigate("/Login")}>
                  Faça Login aqui
                </Link>
              </Text>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
}
